import React, { useEffect, useRef, useState } from "react";
import { useForm, useFieldArray, useWatch } from "react-hook-form";
import { Button, Modal, Form } from "react-bootstrap";
import { BsPlusCircle, BsTrash, BsPencil } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { ConfirmationAlert, getOnlyToken, triggerAlert } from "../../utils/commonFunctions";
import Loader from "../../common/Loader";
import { Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";


export default function Ivr({ goToNextStep, agentType, flowID, goToPreviousStep, ivrid }) {
    const navigate = useNavigate();
    const [audioList, setAudioList] = useState([]);
    const [loading, setLoading] = useState(false)
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [agents, setAgents] = useState([])
    const [showIvrEntities, setShowIvrEntities] = useState(false);
    const [createdIvrData, setCreatedIvrData] = useState(null);
    const [companies, setCompanies] = useState([])
    const [parentcompany, setParentCompany] = useState()
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('text');
    const [agentsLoaded, setAgentsLoaded] = useState(false);
    const [ivrLoaded, setIvrLoaded] = useState(false);
    const [disabled, setdisabled] = useState(false);
    const [mohGroups, setMohGroups] = useState([]);
    const [speechEntries, setSpeechEntries] = useState([]);
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    let obj = {};
    for (let pair of params.entries()) {
        obj[pair[0]] = pair[1];
    }
    const [ivrID, setivrID] = useState(obj["ivrid"] ? obj["ivrid"] : ivrid)

    const isupdate = obj["isupdate"];
    const { company_id, editMode: editModeFromState } = location.state || {};
    const editMode = editModeFromState || isupdate === "true";

    console.log('Company ID:', company_id);
    console.log('Edit Mode:', editMode);
    console.log('IVR ID:', ivrID);
    console.log('Agent Type:', agentType);
    console.log('Flow ID:', flowID);

    // Form 1: IVR Configuration Form
    const {
        register: registerIvr,
        control: controlIvr,
        handleSubmit: handleSubmitIvr,
        reset: resetIvr,
        watch: watchIvr,
        formState: { errors: errorsIvr },
    } = useForm({ shouldUnregister: false });

    const { register: registerSpeech,
        control: controlSpeech,
        handleSubmit: handleSubmitSpeech,
        reset: resetSpeech,
        watch: watchSpeech,
        formState: { errors: errorsSpeech } } = useForm({ shouldUnregister: false });


    // Form 3: IVR Entries Form
    const {
        register: registerEntry,
        control: controlEntry,
        handleSubmit: handleSubmitEntry,
        reset: resetEntry,
        watch: watchEntry,
        formState: { errors: errorsEntry },
    } = useForm({
        shouldUnregister: false,
        defaultValues: {
            ivrEntries: [
                {
                    ivrNumber: "",
                    destinationType: "",
                    destination: "",
                    returnToIvr: false,
                },
            ],
        },
    });


    const token = getOnlyToken();

    const timeoutDestinationType = useWatch({ control: controlIvr, name: "timeoutDestinationType" });
    const invalidDestinationType = useWatch({ control: controlIvr, name: "invalidDestinationType" });



    // useEffect(() => {
    //   if (!editMode) {
    //     setValueIvr("timeoutDestination", "");
    //   }
    // }, [timeoutDestinationType, setValueIvr, editMode]);

    // useEffect(() => {
    //   if (!editMode) {
    //     setValueIvr("invalidDestination", "");
    //   }
    // }, [invalidDestinationType, setValueIvr, editMode]);




    const fetchMohGroups = async () => {
        try {
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const res = await axios.get('/ivr/moh/groups/', config);
            if (res.status === 200) {
                setMohGroups(res.data?.data || res.data || []);
            }
        } catch (error) {
            console.error('Failed to fetch MOH', error);
            setMohGroups([]);
        }
    };

    useEffect(() => {
        fetchAudios()
        fetchAgents()
        //  fetchCompanies()
        fetchIVR(company_id)
        fetchMohGroups()
        if (ivrID !== undefined) {
            fetchIvrDetails(ivrID);
            setShowIvrEntities(true);
        }
    }, [company_id, editMode, ivrID])




    const fetchCompanies = async () => {
        try {
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const res = await axios.get('api/agents/folder/create/', config)
            if (res.status === 200) {
                setCompanies(res.data.folders)
            }
        } catch (error) {
            console.error('Failed to fetch agents for folder', error);
            setCompanies([]);
        }
    }




    const fetchAgents = async () => {
        try {
            setLoading(true)
            const config = { headers: { Authorization: `Bearer ${token}` } };

            const response = await axios.get(`api/admin/agent/list/?agent_type=in-bound`, config);
            if (response.status === 200) {
                // assume agents returned in response.data.agents or response.data.data
                const agents = response.data.data.agents || [];
                console.log(agents, 'agentslist');

                setAgents(agents);
                setAgentsLoaded(true);
            } else {
                setAgents([]);
            }
        } catch (error) {
            console.error('Failed to fetch agents for folder', error);
            setAgents([]);
            setAgentsLoaded(true);
        } finally {
            setLoading(false);
        }
    }


    const [Ivrdata, setIvrData] = useState([])
    const fetchIVR = async (id) => {
        try {

            const config = { headers: { Authorization: `Bearer ${token}` } };

            const res = await axios.get(`api/admin/ivr_config/list/`, config)

            if (res.status === 200) {
                setIvrData(res.data.data.ivr_configs)
                console.log(res.data.data, 'ivrdata');
                setIvrLoaded(true);
            }
        } catch (error) {
            console.log(error, 'errror')
            setIvrLoaded(true);
        }
    }
    const capitalize = (val = "") =>
        val ? val.charAt(0).toUpperCase() + val.slice(1) : "";


    const fetchIvrDetails = async (id) => {
        try {
            setLoading(true);

            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const res = await axios.get(`/ivr/ivr-config/${id}/`, config);

            if (res.status === 200) {
                const d = res.data;

                setParentCompany(d.company);

                if (res.data.greeting_type === "speech") {
                    setActiveTab('speech')
                    resetSpeech(
                        {
                            ivrname: d.ivr_name ?? "",
                            speechDescription: d.ivr_description ?? "",
                            speechAgent: d.speech_agent ?? "",
                            speechMoh: d.moh ?? "",
                        },
                        {
                            keepDirty: false,
                            keepTouched: false,
                        }
                    );
                    if (Array.isArray(d.speech_agent_destinations) && d.speech_agent_destinations.length > 0) {
                        setSpeechEntries(d.speech_agent_destinations.map(e => ({
                            type: e.type || "",
                            agent: e.destination_agent ? String(e.destination_agent) : ""
                        })));
                    }
                    return;
                } else {
                    resetIvr(
                        {
                            ivrName: d.ivr_name ?? "",
                            ivrDescription: d.ivr_description ?? "",
                            ivrAudio: d.greeting_audio_path ?? "",

                            timeoutRetries:
                                d.timeout_retries != null ? d.timeout_retries : "",
                            ringTimeout:
                                d.ring_timeout_seconds != null
                                    ? d.ring_timeout_seconds
                                    : "",
                            moh: d.moh ?? "",

                            timeoutDestinationType: capitalize(d.timeout_destination_type),
                            timeoutDestination: d.timeout_destination_agent
                                ? d.timeout_destination_agent
                                : d.timeout_destination_ivr
                                    ? d.timeout_destination_ivr
                                    : "",

                            timeoutRetriesAudio: d.timeout_retries_audio ?? "",
                            noinputtimeout:
                                d.no_input_timeout != null
                                    ? d.no_input_timeout
                                    : "",

                            invalidretries:
                                d.invalid_retries != null ? d.invalid_retries : "",
                            invalidRetryAudio: d.invalid_retry_audio ?? "",
                            invalidFinalAudio: d.invalid_final_audio ?? "",

                            invalidDestinationType: capitalize(d.invalid_destination_type),
                            invalidDestination: d.invalid_destination_agent
                                ? d.invalid_destination_agent
                                : d.invalid_destination_ivr
                                    ? d.invalid_destination_ivr
                                    : "",
                        },
                        {
                            keepDirty: false,
                            keepTouched: false,
                        }
                    );
                }
               

                setCreatedIvrData(d);
                setShowIvrEntities(true);

                /* ---------------------------
                   IVR ENTRIES (FieldArray)
                ---------------------------- */
                if (Array.isArray(d.ivr_entries) && d.ivr_entries.length > 0) {
                    resetEntry({
                        ivrEntries: d.ivr_entries.map((e) => ({
                            id: e.id,
                            ivrNumber: String(e.entry_number),

                            destinationType: capitalize(e.destination_type),

                            destination: e.destination_agent
                                ? e.destination_agent
                                : e.destination_ivr
                                    ? e.destination_ivr
                                    : "",

                            returnToIvr: e.return_to_ivr === true ? 1 : 0,
                        })),
                    });
                } else {
                    resetEntry({
                        ivrEntries: [
                            {
                                ivrNumber: "",
                                destinationType: "",
                                destination: "",
                                returnToIvr: false,
                            },
                        ],
                    });
                }
            }
        } catch (error) {
            console.error("Error fetching IVR details:", error);
        } finally {
            setLoading(false);
        }
    };


    console.log("AFTER RESET:", watchIvr());


    const fetchAudios = async () => {
        try {
            setLoading(true);

            const config = { headers: { Authorization: `Bearer ${token}` } };

            const res = await axios.get(`api/admin/ivr_audio/list/`, config)

            if (res.status === 200) {
                setAudioList(res.data.data)
                console.log(res.data.data, 'audiolist');

            }
        } catch (error) {
            console.log(error, 'errror')
        } finally {
            setLoading(false);

        }
    }



    const { fields, append, remove } = useFieldArray({
        control: controlEntry,
        name: "ivrEntries",
    });

    const handleIvrCreate = handleSubmitIvr(async (data) => {
        try {
            setLoading(true);
            const config = { headers: { Authorization: `Bearer ${token}` } };

            const payload = {
                // company: data.company,
                ivr_name: data.ivrName,
                ivr_description: data.ivrDescription || "",
                greeting_type: "text",
                greeting_audio_file_name: data.ivrAudio,
                timeout_retries_audio: data.timeoutRetriesAudio,
                timeout_destination_type: data.timeoutDestinationType.toLowerCase(),
                timeout_destination_agent: data.timeoutDestinationType === "Agent" ? parseInt(data.timeoutDestination) : null,
                timeout_destination_ivr: data.timeoutDestinationType === "Ivr" ? parseInt(data.timeoutDestination) : null,
                timeout_retries: parseInt(data.timeoutRetries),
                invalid_destination_type: data.invalidDestinationType.toLowerCase(),
                invalid_destination_agent: data.invalidDestinationType === "Agent" ? parseInt(data.invalidDestination) : null,
                invalid_destination_ivr: data.invalidDestinationType === "Ivr" ? parseInt(data.invalidDestination) : null,
                invalid_retries: parseInt(data.invalidretries),
                no_input_timeout: parseInt(data.noinputtimeout),
                invalid_retry_audio: data.invalidRetryAudio,
                invalid_final_audio: data.invalidFinalAudio,
                ring_timeout_seconds: parseInt(data.ringTimeout),
                moh: data.moh ? parseInt(data.moh) : null
            };


            if (ivrID !== undefined) {
                const res = await axios.put(`api/admin/ivr_config/${ivrID}/update/`, payload, config);
                if (res.status === 200 || res.status === 201) {
                    setSuccessMessage('IVR configuration updated successfully!');
                    setShowSuccessModal(true);
                    navigate('/configurations/ivrconfigurations')
                    //goToNextStep();
                }

            } else {
                const res = await axios.post('api/admin/ivr_config/create/', payload, config);
                if (res.status === 201 || res.status === 200) {
                    // Normalize created object from response to avoid throwing when shape differs
                    const created = res.data?.data ?? res.data ?? null;
                    // Try to extract company id safely from different response shapes
                    const companyId = created?.external_api_response?.companyId ?? created?.company ?? null;
                    if (companyId) setParentCompany(companyId);
                    setCreatedIvrData(created);

                    setShowIvrEntities(true);
                    setSuccessMessage(res.data?.message || 'IVR created successfully! You can now add IVR entries.');
                    setShowSuccessModal(true);

                }
            }
        } catch (error) {
            setErrorMessage(error.response?.data?.message || 'Failed to save IVR');
            setShowErrorModal(true);
        } finally {
            setLoading(false);
        }
    }, (errors) => {
        console.log('Form validation errors:', errors);
    });

    console.log(createdIvrData, 'dafafa')

    const handleIvrEntitiesSave = handleSubmitEntry(async (data) => {
        try {
            setLoading(true);
            const config = { headers: { Authorization: `Bearer ${token}` } };

            const entries = data.ivrEntries.map(entry => {
                const entryData = {
                    entry_number: parseInt(entry.ivrNumber),
                    destination_type: entry.destinationType?.toLowerCase(),
                    return_to_ivr: entry.returnToIvr ? 1 : 0
                };

                if (entry.id) {
                    entryData.id = entry.id;
                }

                if (entry.destinationType === "Agent" && entry.destination) {
                    entryData.destination_agent = parseInt(entry.destination);
                }
                if (entry.destinationType === "Ivr" && entry.destination) {
                    entryData.destination_ivr = parseInt(entry.destination);
                }

                return entryData;
            });

            const payload = {
                parent_ivr: createdIvrData.id,
                companyId: parentcompany,
                entries
            };
            await axios.post(`api/admin/ivr_entry/sync/`, payload, config)

            // await fetchIvrDetails(ivrID)

            setSuccessMessage('IVR entries saved successfully!');
            navigate('/configurations/ivrconfigurations')
            setShowSuccessModal(true);

        } catch (error) {
            console.error('Error saving IVR entries:', error);
            setErrorMessage(error.response?.data?.message || 'Failed to save IVR entries');
            setShowErrorModal(true);
        } finally {
            setLoading(false);
        }
    });


    const deleteIvrentry = (index) => {
        const entryId = watchEntry(`ivrEntries.${index}.id`);
        if (!entryId) {
            remove(index);
            return;
        }
        ConfirmationAlert(
            `You won't be able to revert this IVR entry!`,
            'Yes, delete it!',
            () => handleDeleteIvrEntry(entryId)
        );
    }

    const handleDeleteIvrEntry = async (entryId) => {
        try {
            setLoading(true);
            const config = { headers: { Authorization: `Bearer ${token}` } };
            await axios.delete(`/api/admin/ivr_entry/${entryId}/delete/`, config);
            await fetchIvrDetails(ivrID);
            setSuccessMessage('IVR entry deleted successfully!');
            setShowSuccessModal(true);
        } catch (error) {
            setErrorMessage(error.response?.data?.message || 'Failed to delete IVR entry');
            setShowErrorModal(true);
        } finally {
            setLoading(false);
        }
    }
    const addSpeechEntry = () => {
        setSpeechEntries([...speechEntries, { type: "", agent: "" }]);
    };

    const removeSpeechEntry = (index) => {
        const updated = [...speechEntries];
        updated.splice(index, 1);
        setSpeechEntries(updated);
    };

    const changeSpeechEntry = (value, index, field) => {
        const updated = [...speechEntries];
        updated[index][field] = value;
        setSpeechEntries(updated);
    };

    const handleSpeechSave = handleSubmitSpeech(async(data)=>{

        try {
            setLoading(true);
           const config = { headers: { Authorization: `Bearer ${token}` } };

            const payload = {
                ivr_name: data.ivrname,
                ivr_description: data.speechDescription || "",
                greeting_type: "speech",
                agent_id: parseInt(data.speechAgent),
                moh: data.moh ? parseInt(data.moh) : null,
                sub_agents: speechEntries.filter(e => e.type && e.agent).map(e => ({
                    type: e.type,
                    destination_agent_id: parseInt(e.agent)
                }))
            }

            if (editMode && ivrID) {
                const resp = await axios.put(`api/admin/ivr_config/${ivrID}/update/`, payload, config);
                if (resp.status === 200 || resp.status === 201) {
                    setSuccessMessage('IVR updated successfully!');
                    setShowSuccessModal(true);
                    setTimeout(() => navigate('/configurations/ivrconfigurations'), 1000)
                }
            }else{
                const res = await axios.post(`/api/admin/ivr_config/create/`, payload, config);
                if(res.status === 200 || res.status === 201){
                    setSuccessMessage('IVR created successfully!');
                    setShowSuccessModal(true);
                   setTimeout(() => navigate('/configurations/ivrconfigurations'), 1000)
                }
            }

        } catch (error) {
            console.error('Error saving IVR:', error);
            setErrorMessage(error.response?.data?.message || 'Failed to save IVR');
            setShowErrorModal(true);
        }finally{
            setLoading(false);
        }
    })
    


    // Audio modal + form state (for Add Audio feature)
    const [showAudioModal, setShowAudioModal] = useState(false);
    const [voices, setVoices] = useState([]);
    const {
        register: registerAudio,
        control: controlAudio,
        handleSubmit: handleSubmitAudio,
        reset: resetAudio,
        setValue: setValueAudio,
        formState: { errors: errorsAudio },
    } = useForm();

    const selectedGender = useWatch({ control: controlAudio, name: "gender" });
    const watchedLanguage = useWatch({ control: controlAudio, name: "language" });

    useEffect(() => {
        setValueAudio("voice", "");
        if (watchedLanguage && selectedGender) {
            fetchVoices(watchedLanguage, selectedGender);
        }
    }, [watchedLanguage, selectedGender]);

    const fetchVoices = async (languageCode, gender) => {
        try {
            const config = { headers: { Authorization: `Bearer ${'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzY5ODQ4NjkzLCJpYXQiOjE3Njg5ODQ2OTMsImp0aSI6ImRmMjBiYmFmZmIyNTQzZTA5NGI5NzlkOThiNmQ4NjBmIiwidXNlcl9pZCI6Mn0.bNFX9uOtlSP87TMDTYY6R27uK-gOF9pWUeEdxKT89nU'}` } };
            const payload = {
                language_code: languageCode,
                gender: gender.toLowerCase(),
            };

            console.log('Fetching voices with payload:', payload);
            const res = await axios.post(`https://callingbot.vitelglobal.com/tts/voices`, payload, config);

            if (res.status === 200) {
                setVoices(res.data.voices || []);
            }
        } catch (error) {
            console.error('Error fetching voices:', error?.response?.data || error?.message);
            setVoices([]);
        }
    };

    const handleAudioSave = handleSubmitAudio(async (data) => {
        try {
            setLoading(true);
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const payload = {
                text: data.description,
                filename: data.audioName,
                language_code: data.language,
                voice_name: data.voice,
                is_default: true,
                // companyId: data.company (if needed)
            };

            const res = await axios.post('api/admin/ivr_audio/generate/', payload, config);

            if (res.status === 200 || res.status === 201) {
                await fetchAudios();
                setSuccessMessage('Audio created successfully!');
                setShowSuccessModal(true);
                resetAudio();
                setShowAudioModal(false);
            }
        } catch (error) {
            console.error('Error creating audio:', error);
            setErrorMessage(error.response?.data?.message || 'Failed to create audio');
            setShowErrorModal(true);
        } finally {
            setLoading(false);
        }
    });

    const handleFlowlist = async (ivrId, agentTypeParam) => {
        try {
            setdisabled(true);
            const tokenLocal = getOnlyToken();
            const config = {
                headers: {
                    'Authorization': `Bearer ${tokenLocal}`,
                    'Content-Type': 'application/json'
                }
            }
            const payload = {
                id: flowID,
                flow_type: agentTypeParam || agentType,
            }

            // include Ivr key when an IVR id is provided
            if (ivrId) {
                payload.ivr = ivrId;
            }

            const response = await axios.post('/api/admin/default_agent_flow/save/', payload, config);

            if (response.status === 200 || response.status === 201) {
                return true;
            }
        } catch (error) {
            console.error('Error creating agent/IVR flow:', error);
            triggerAlert('error', '', error.response?.data?.message || 'Failed to create agent flow');
        } finally {
            setdisabled(false);
        }
        return false;
    }


    return (


        <div id='layout-wrapper'>
            <Header />
            <Sidebar />
            <div className='page-content'>

                <div className="main-content">
                    <div className="container-fluid ">

                        {loading && (
                            <div className="full-page-loader-overlay">
                                <Loader />
                            </div>
                        )}
                        <div className="  container-fluid border border-0  " >
                            <div className="">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h4 style={{ color: "#014670" }} className="fw-bold  mb-4">{ivrID ? "Edit Ivr" : "Create Ivr"}</h4>
                                    <button
                                        onClick={() => navigate('/configurations/ivrconfigurations')}
                                        className="btn btn-primary btn-sm d-flex fs-6 align-items-center gap-1 px-3"
                                    >
                                        <i className="bi bi-arrow-left"></i>
                                        Back
                                    </button>
                                </div>
                                 <div className="d-flex justify-content-end mb-3">
                        <div
                            className="d-flex align-items-center p-1  rounded-pill"
                            style={{
                                background: "#e6e9f5",
                                border: "1px solid #3f3f3f",
                                gap: "4px",
                            }}
                        >
                            <button
                                className={`btn rounded-pill  px-4 ${activeTab === "text" ? "btn-primary " : ""
                                    }`}
                                onClick={() => setActiveTab("text")}
                                disabled={loading}
                            >
                                Text
                            </button>

                            <button
                                className={`btn rounded-pill px-4 ${activeTab === "speech" ? "btn-primary" : ""
                                    }`}
                                onClick={() => setActiveTab("speech")}
                                disabled={loading}
                            >
                                Speech
                            </button>
                        </div>
                    </div> 
                                {activeTab === "text" &&
                                    <>
                                        <div className="row g-4 mb-4">
                                            {/* Left Column: Basic IVR Configuration */}
                                            <div className="col-md-6">
                                                <div className="p-4 bg-white border rounded-3 h-100">
                                                    <h5 className="d-flex align-items-center mb-3">
                                                        <i className="bi bi-telephone-fill me-2" style={{ color: '#014670' }}></i>
                                                        Basic IVR Configuration
                                                        <Tooltip title="Configure the core IVR settings including name, audio, and timeout values" arrow placement="top">
                                                            <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                        </Tooltip>
                                                    </h5>
                                                    <div className="row g-3">
                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    IVR Name <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Enter a unique name to identify this IVR configuration" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <input
                                                                placeholder="Eg : Office Reception IVR"
                                                                className={`form-control ${errorsIvr.ivrName ? 'is-invalid' : ''}`}
                                                                {...registerIvr("ivrName", { required: "IVR Name is required" })}
                                                            />
                                                            {errorsIvr.ivrName && <div className="invalid-feedback d-block">{errorsIvr.ivrName.message}</div>}
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    Timeout Retries <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Number of times the system will retry when caller doesn't respond within timeout period" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <input
                                                                placeholder="Eg : 3"
                                                                className={`form-control ${errorsIvr.timeoutRetries ? 'is-invalid' : ''}`}
                                                                type="number"
                                                                {...registerIvr("timeoutRetries", { required: "Timeout Retries is required" })}
                                                            />
                                                            {errorsIvr.timeoutRetries && <div className="invalid-feedback d-block">{errorsIvr.timeoutRetries.message}</div>}
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    Select Audio <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Choose the greeting audio file that callers will hear when they reach this IVR" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                                <select
                                                                    className={`form-select ${errorsIvr.ivrAudio ? 'is-invalid' : ''}`}
                                                                    {...registerIvr("ivrAudio", { required: "Audio is required" })}
                                                                >
                                                                    <option value="">-- -- Select Audio -- --</option>
                                                                    {audioList.map((a, i) => (
                                                                        <option key={i} value={a.filename}>
                                                                            {a.filename}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-sm ms-2 d-flex align-items-center"
                                                                    onClick={() => setShowAudioModal(true)}
                                                                >
                                                                    <i className="bi bi-plus-circle me-1"></i>Audio
                                                                </button>
                                                            </div>
                                                            {errorsIvr.ivrAudio && <div className="invalid-feedback d-block">{errorsIvr.ivrAudio.message}</div>}
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    Ring Timeout (seconds) <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Maximum time in seconds to wait for an agent to answer before timing out" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <input
                                                                placeholder="Eg : 30"
                                                                className={`form-control ${errorsIvr.ringTimeout ? 'is-invalid' : ''}`}
                                                                type="number"
                                                                {...registerIvr("ringTimeout", { required: "Ring Timeout is required" })}
                                                            />
                                                            {errorsIvr.ringTimeout && <div className="invalid-feedback d-block">{errorsIvr.ringTimeout.message}</div>}
                                                        </div>

                                                         
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Right Column: Timeout Settings */}
                                            <div className="col-md-6">
                                                <div className="p-4 bg-white border rounded-3 h-100">
                                                    <h5 className="d-flex align-items-center mb-3">
                                                        <i className="bi bi-clock-fill me-2" style={{ color: '#014670' }}></i>
                                                        Timeout Settings
                                                        <Tooltip title="Configure timeout behavior including destination and retry audio" arrow placement="top">
                                                            <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                        </Tooltip>
                                                    </h5>
                                                    <div className="row g-3">
                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    Timeout Destination <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Choose where to route calls when timeout retries are exhausted (Agent or IVR)" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <select
                                                                className={`form-select ${errorsIvr.timeoutDestinationType ? 'is-invalid' : ''}`}
                                                                {...registerIvr("timeoutDestinationType", { required: "Timeout Destination Type is required" })}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="Agent">Agent</option>
                                                                <option value="Ivr">IVR</option>
                                                            </select>
                                                            {errorsIvr.timeoutDestinationType && <div className="invalid-feedback d-block">{errorsIvr.timeoutDestinationType.message}</div>}
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    Timeout Retries Audio <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Audio message played to caller when they don't respond within the timeout period" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <select
                                                                className={`form-select ${errorsIvr.timeoutRetriesAudio ? 'is-invalid' : ''}`}
                                                                {...registerIvr("timeoutRetriesAudio", { required: "Timeout Retries Audio is required" })}
                                                            >
                                                                <option value="">-- Select Audio --</option>
                                                                {audioList.map((a, i) => (
                                                                    <option key={i} value={a.filename}>
                                                                        {a.filename}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errorsIvr.timeoutRetriesAudio && <div className="invalid-feedback d-block">{errorsIvr.timeoutRetriesAudio.message}</div>}
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    {timeoutDestinationType ? `Select ${timeoutDestinationType}` : "Destination"} <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Select the specific agent or IVR to route timeout calls to" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <select
                                                                key={`timeout-${timeoutDestinationType}`}
                                                                className={`form-select ${errorsIvr.timeoutDestination ? 'is-invalid' : ''}`}
                                                                disabled={!timeoutDestinationType}
                                                                {...registerIvr("timeoutDestination", { required: "Destination is required" })}
                                                            >
                                                                <option value="">
                                                                    {timeoutDestinationType ? `Select ${timeoutDestinationType}` : "Select Destination"}
                                                                </option>
                                                                {timeoutDestinationType === "Agent" &&
                                                                    agents.map((agent) => (
                                                                        <option key={agent.agent_id} value={agent.agent_id}>
                                                                            {agent.agent_name}
                                                                        </option>
                                                                    ))}
                                                                {timeoutDestinationType === "Ivr" &&
                                                                    Ivrdata.map((ivr) => (
                                                                        <option key={ivr.id} value={ivr.id}>
                                                                            {ivr.ivr_name}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                            {errorsIvr.timeoutDestination && <div className="invalid-feedback d-block">{errorsIvr.timeoutDestination.message}</div>}
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    No Input Timeout (seconds) <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Time in seconds to wait for caller input before considering it as no input" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <input
                                                                placeholder="Eg : 30"
                                                                className={`form-control ${errorsIvr.noinputtimeout ? 'is-invalid' : ''}`}
                                                                type="number"
                                                                {...registerIvr("noinputtimeout", { required: "No Input Timeout is required" })}
                                                            />
                                                            {errorsIvr.noinputtimeout && <div className="invalid-feedback d-block">{errorsIvr.noinputtimeout.message}</div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row g-4">
                                            {/* Left Column: Invalid Input Settings */}
                                            <div className="col-md-6">
                                                <div className="p-4 bg-white border rounded-3 h-100">
                                                    <h5 className="d-flex align-items-center mb-3">
                                                        <i className="bi bi-exclamation-triangle-fill me-2" style={{ color: '#014670' }}></i>
                                                        Invalid Input Settings
                                                        <Tooltip title="Configure behavior for invalid caller input" arrow placement="top">
                                                            <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                        </Tooltip>
                                                    </h5>
                                                    <div className="row g-3">
                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    Invalid Retries <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Number of times to retry when caller enters invalid input before routing to destination" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <input
                                                                placeholder="Eg : 2"
                                                                className={`form-control ${errorsIvr.invalidretries ? 'is-invalid' : ''}`}
                                                                type="number"
                                                                {...registerIvr("invalidretries", { required: "Invalid Retries is required" })}
                                                            />
                                                            {errorsIvr.invalidretries && <div className="invalid-feedback d-block">{errorsIvr.invalidretries.message}</div>}
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    Invalid Destination <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Choose where to route calls when invalid input retries are exhausted (Agent or IVR)" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <select
                                                                className={`form-select ${errorsIvr.invalidDestinationType ? 'is-invalid' : ''}`}
                                                                {...registerIvr("invalidDestinationType", { required: "Invalid Destination Type is required" })}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="Agent">Agent</option>
                                                                <option value="Ivr">IVR</option>
                                                            </select>
                                                            {errorsIvr.invalidDestinationType && <div className="invalid-feedback d-block">{errorsIvr.invalidDestinationType.message}</div>}
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    {invalidDestinationType ? `Select ${invalidDestinationType}` : "Destination"} <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Select the specific agent or IVR to route invalid input calls to" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <select
                                                                key={`invalid-${invalidDestinationType}`}
                                                                className={`form-select ${errorsIvr.invalidDestination ? 'is-invalid' : ''}`}
                                                                disabled={!invalidDestinationType}
                                                                {...registerIvr("invalidDestination", { required: "Destination is required" })}
                                                            >
                                                                <option value="">
                                                                    {invalidDestinationType ? `Select ${invalidDestinationType}` : "Select Destination"}
                                                                </option>
                                                                {invalidDestinationType === "Agent" &&
                                                                    agents.map((agent) => (
                                                                        <option key={agent.agent_id} value={agent.agent_id}>
                                                                            {agent.agent_name}
                                                                        </option>
                                                                    ))}
                                                                {invalidDestinationType === "Ivr" &&
                                                                    Ivrdata.map((ivr) => (
                                                                        <option key={ivr.id} value={ivr.id}>
                                                                            {ivr.ivr_name}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                            {errorsIvr.invalidDestination && <div className="invalid-feedback d-block">{errorsIvr.invalidDestination.message}</div>}
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    Invalid Retry Audio <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Audio message played when caller enters invalid input and system is retrying" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <select
                                                                className={`form-select ${errorsIvr.invalidRetryAudio ? 'is-invalid' : ''}`}
                                                                {...registerIvr("invalidRetryAudio", { required: "Invalid Retry Audio is required" })}
                                                            >
                                                                <option value="">-- Select Audio --</option>
                                                                {audioList.map((a, i) => (
                                                                    <option key={i} value={a.filename}>
                                                                        {a.filename}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errorsIvr.invalidRetryAudio && <div className="invalid-feedback d-block">{errorsIvr.invalidRetryAudio.message}</div>}
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    Invalid Final Audio <span className='text-danger'>*</span>
                                                                </label>
                                                                <Tooltip title="Final audio message played before routing to destination after all invalid retries are exhausted" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <select
                                                                className={`form-select ${errorsIvr.invalidFinalAudio ? 'is-invalid' : ''}`}
                                                                {...registerIvr("invalidFinalAudio", { required: "Invalid Final Audio is required" })}
                                                            >
                                                                <option value="">-- Select Audio --</option>
                                                                {audioList.map((a, i) => (
                                                                    <option key={i} value={a.filename}>
                                                                        {a.filename}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errorsIvr.invalidFinalAudio && <div className="invalid-feedback d-block">{errorsIvr.invalidFinalAudio.message}</div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Right Column: Additional Information */}
                                            <div className="col-md-6">
                                                <div className="p-4 bg-white border rounded-3 h-100">
                                                    <h5 className="d-flex align-items-center mb-3">
                                                        <i className="bi bi-file-text-fill me-2" style={{ color: '#014670' }}></i>
                                                        Additional Information
                                                        <Tooltip title="Add notes about this IVR flow" arrow placement="top">
                                                            <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                        </Tooltip>
                                                    </h5>
                                                    <div className="row g-3">

                                                        <div className="col-md-12">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    Description
                                                                </label>
                                                                <Tooltip title="Optional description to document the purpose and functionality of this IVR configuration" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <textarea
                                                                placeholder="Briefly describe the purpose of this IVR flow"
                                                                rows={7}
                                                                className="form-control"
                                                                {...registerIvr("ivrDescription")}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {showIvrEntities && (
                                            <div className="p-4 mb-4 bg-white border rounded-3 mt-4">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h5 className="d-flex align-items-center mb-0">
                                                        <i className="bi bi-list me-2" style={{ color: '#014670' }}></i>
                                                        IVR Entries
                                                        <Tooltip title="Define menu options and routing for IVR entries" arrow placement="top">
                                                            <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                        </Tooltip>
                                                    </h5>
                                                    <BsPlusCircle
                                                        size={22}
                                                        className="text-success cursor-pointer"
                                                        onClick={() =>
                                                            append({
                                                                ivrNumber: "",
                                                                destinationType: "",
                                                                destination: "",
                                                                returnToIvr: false,
                                                            })
                                                        }
                                                    />
                                                </div>
                                                {/* ===== LABEL ROW (ADD HERE — OUTSIDE map) ===== */}
                                                <div className="row g-3 mb-1 fw-semibold text-muted small">
                                                    <div className="col-auto">#</div>

                                                    <div className="col-md-2">
                                                        <label className="form-label mb-0">
                                                            Key <span className="text-danger">*</span>
                                                            <Tooltip title="Enter the digit key (0-9) that callers will press to select this option" arrow placement="top">
                                                                <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 0.5 }} />
                                                            </Tooltip>
                                                            <small className="d-block text-muted">(0–9 only)</small>
                                                        </label>
                                                    </div>

                                                    <div className="col-md-2">
                                                        <label className="form-label mb-0">
                                                            Destination Type <span className="text-danger">*</span>
                                                            <Tooltip title="Select where this IVR entry should route to (Agent or IVR)" arrow placement="top">
                                                                <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 0.5 }} />
                                                            </Tooltip>
                                                        </label>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <label className="form-label mb-0">
                                                            Destination <span className="text-danger">*</span>
                                                            <Tooltip title="Choose the specific agent or IVR to route calls to" arrow placement="top">
                                                                <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 0.5 }} />
                                                            </Tooltip>
                                                        </label>
                                                    </div>

                                                    <div className="col-md-2">
                                                        <label className="form-label mb-0">
                                                            Return to IVR
                                                            <Tooltip title="Enable to return to this IVR after the routed destination completes" arrow placement="top">
                                                                <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 0.5 }} />
                                                            </Tooltip>
                                                        </label>
                                                    </div>

                                                    <div className="col-auto">
                                                        <label className="form-label mb-0">Action</label>
                                                    </div>
                                                </div>
                                                {fields.map((field, index) => {
                                                    const entryDestinationType = watchEntry(`ivrEntries.${index}.destinationType`);
                                                    return (
                                                        <div className="row g-3 mb-2 align-items-center" key={field.id}>
                                                            <input type="hidden" {...registerEntry(`ivrEntries.${index}.id`)} />
                                                            <div className="col-auto">
                                                                <span className="fw-bold">{index + 1}</span>
                                                            </div>

                                                            <div className="col-md-2">
                                                                <input
                                                                    className={`form-control ${errorsEntry.ivrEntries?.[index]?.ivrNumber ? 'is-invalid' : ''}`}
                                                                    placeholder="Key (e.g., 1)"
                                                                    {...registerEntry(`ivrEntries.${index}.ivrNumber`, {
                                                                        required: "Key is required",
                                                                        pattern: {
                                                                            value: /^[0-9]$/,
                                                                            message: "Only 0–9 allowed"
                                                                        }
                                                                    })}


                                                                />
                                                                {errorsEntry.ivrEntries?.[index]?.ivrNumber && (
                                                                    <div className="invalid-feedback d-block">{errorsEntry.ivrEntries[index].ivrNumber.message}</div>
                                                                )}
                                                            </div>

                                                            <div className="col-md-2">
                                                                <select
                                                                    className={`form-select ${errorsEntry.ivrEntries?.[index]?.destinationType ? 'is-invalid' : ''}`}
                                                                    {...registerEntry(`ivrEntries.${index}.destinationType`, { required: "Type is required" })}
                                                                >
                                                                    <option value="">Select Type</option>
                                                                    <option value="Agent">Agent</option>
                                                                    <option value="Ivr">IVR</option>
                                                                </select>
                                                                {errorsEntry.ivrEntries?.[index]?.destinationType && (
                                                                    <div className="invalid-feedback d-block">{errorsEntry.ivrEntries[index].destinationType.message}</div>
                                                                )}
                                                            </div>

                                                            <div className="col-md-3">
                                                                <select
                                                                    key={`entry-${index}-${entryDestinationType}`}
                                                                    className={`form-select ${errorsEntry.ivrEntries?.[index]?.destination ? 'is-invalid' : ''}`}
                                                                    disabled={!entryDestinationType}
                                                                    {...registerEntry(`ivrEntries.${index}.destination`, { required: "Destination is required" })}
                                                                >
                                                                    <option value="">
                                                                        {entryDestinationType ? `Select ${entryDestinationType}` : "Select Destination"}
                                                                    </option>
                                                                    {entryDestinationType === "Agent" &&
                                                                        agents.map((agent) => (
                                                                            <option key={agent.agent_id} value={agent.agent_id}>
                                                                                {agent.agent_name}
                                                                            </option>
                                                                        ))}
                                                                    {entryDestinationType === "Ivr" &&
                                                                        Ivrdata.map((ivr) => (
                                                                            <option key={ivr.id} value={ivr.id}>
                                                                                {ivr.ivr_name}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                                {errorsEntry.ivrEntries?.[index]?.destination && (
                                                                    <div className="invalid-feedback d-block">{errorsEntry.ivrEntries[index].destination.message}</div>
                                                                )}
                                                            </div>

                                                            <div className="col-md-2">
                                                                <input
                                                                    type="checkbox"
                                                                    className="me-2"
                                                                    {...registerEntry(`ivrEntries.${index}.returnToIvr`)}
                                                                />
                                                                Return to IVR
                                                            </div>

                                                            <div className="col-auto">
                                                                <BsTrash
                                                                    size={18}
                                                                    className="text-danger cursor-pointer"
                                                                    title="Delete"
                                                                    onClick={() => deleteIvrentry(index)}
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                })}

                                                <div className="d-flex justify-content-end gap-2 mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={handleIvrEntitiesSave}
                                                    >
                                                        <i className="bi bi-save me-1"></i> {editMode ? 'Update Entries' : 'Save Entries'}
                                                    </button>
                                                </div>
                                            </div>
                                        )}

                                        <div className="d-flex justify-content-end gap-2 mt-4">
                                            {/* {isupdate ? <>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary"
                                                    onClick={() => goToPreviousStep()}
                                                    hidden={!isupdate && showIvrEntities}
                                                >
                                                    Previous Step
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-outline-warning"
                                                    onClick={() => navigate('/configurations/ivrconfigurations')}
                                                    hidden={!isupdate && showIvrEntities}
                                                >
                                                    {isupdate ? <><i className="bi bi-skip-forward me-1"></i> Skip for Now </> : <><i className="bi bi-arrow-right-circle me-1"></i> Next Step</>}
                                                </button>
                                            </> :

                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={() => navigate('/configurations/ivrconfigurations')}
                                                    hidden={!isupdate && showIvrEntities}
                                                >
                                                    cancel
                                                </button>
                                            } */}

                                               <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={() => navigate('/configurations/ivrconfigurations')}
                                                    hidden={!isupdate && showIvrEntities}
                                                >
                                                    cancel
                                                </button>

                                            {ivrID !== undefined ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={(e) => {
                                                        console.log('Update IVR Configuration button clicked');
                                                        handleIvrCreate(e);
                                                    }}
                                                >
                                                    <i className="bi bi-check-circle me-1"></i> Update IVR Configuration
                                                </button>
                                            ) : (
                                                !showIvrEntities ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={handleIvrCreate}
                                                    >
                                                        <i className="bi bi-check-circle me-1"></i> Save IVR
                                                    </button>
                                                ) : (
                                                    <>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-warning"
                                                            onClick={async () => {
                                                                // In create mode, attempt to assign the created IVR to the flow before skipping.
                                                                navigate('/configurations/ivrconfigurations')

                                                            }}
                                                        >
                                                            <i className="bi bi-skip-forward me-1"></i> Skip for Now
                                                        </button>
                                                    </>
                                                )
                                            )}
                                        </div>
                                    </>}

                                {activeTab === 'speech' &&
                                    <>
                                        <div className="row g-4 mb-4">
                                            {/* Left Column: Speech IVR Configuration */}
                                            <div className="col-md-6">
                                                <div className="p-4 bg-white border rounded-3 h-100">
                                                    <h5 className="d-flex align-items-center mb-3">
                                                        <i className="bi bi-mic-fill me-2" style={{ color: '#014670' }}></i>
                                                        Speech IVR Configuration
                                                        <Tooltip title="Configure the speech-based IVR settings including name and agent" arrow placement="top">
                                                            <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                        </Tooltip>
                                                    </h5>
                                                    <div className="row g-3">
                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    IVR Name <span className="text-danger">*</span>
                                                                </label>
                                                                <Tooltip title="Enter a unique name to identify this IVR configuration" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <input
                                                                {...registerSpeech('ivrname', {
                                                                    required: 'IVR Name is required',
                                                                    pattern: {
                                                                        value: /^[a-zA-Z\s]+$/,
                                                                        message: 'Only letters and spaces are allowed (no numbers or symbols)'
                                                                    },
                                                                    maxLength: { value: 50, message: 'Maximum length is 50 characters' }
                                                                })}
                                                                className={`form-control ${errorsSpeech.ivrname ? 'is-invalid' : ''}`}
                                                                placeholder="Eg : Office Reception IVR"
                                                            />
                                                            {errorsSpeech.ivrname && <div className="invalid-feedback d-block">{errorsSpeech.ivrname.message}</div>}
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    Agent <span className="text-danger">*</span>
                                                                </label>
                                                                <Tooltip title="Select the agent to handle speech-to-text inputs" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <select
                                                                className={`form-select ${errorsSpeech.speechAgent ? 'is-invalid' : ''}`}
                                                                {...registerSpeech('speechAgent', { required: 'Agent selection is required' })}
                                                            >
                                                                <option value="">-- Select Agent --</option>
                                                                {agents.map((agent) => (
                                                                    <option key={agent.agent_id} value={agent.agent_id}>
                                                                        {agent.agent_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errorsSpeech.speechAgent && <div className="invalid-feedback d-block">{errorsSpeech.speechAgent.message}</div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Right Column: Additional Information */}
                                            <div className="col-md-6">
                                                <div className="p-4 bg-white border rounded-3 h-100">
                                                    <h5 className="d-flex align-items-center mb-3">
                                                        <i className="bi bi-file-text-fill me-2" style={{ color: '#014670' }}></i>
                                                        Additional Information
                                                        <Tooltip title="Add notes about this IVR flow" arrow placement="top">
                                                            <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                        </Tooltip>
                                                    </h5>
                                                    <div className="row g-3">
                                                        <div className="col-md-12">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label className="form-label mb-0">
                                                                    Description
                                                                </label>
                                                                <Tooltip title="Optional description to document the purpose and functionality of this IVR configuration" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                </Tooltip>
                                                            </div>
                                                            <textarea
                                                                {...registerSpeech('speechDescription')}
                                                                rows={3}
                                                                className="form-control"
                                                                placeholder="Briefly describe the purpose of this IVR flow"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Speech Entries Section */}
                                        <div className="p-4 bg-white border rounded-3">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h5 className="d-flex align-items-center mb-0">
                                                    <i className="bi bi-list-ul me-2" style={{ color: '#014670' }}></i>
                                                    Speech Entries
                                                    <Tooltip title="Define speech-based routing entries with type and destination agent" arrow placement="top">
                                                        <InfoOutlined sx={{ fontSize: 14, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                    </Tooltip>
                                                </h5>
                                                <button type="button" className="btn btn-sm btn-primary d-flex align-items-center gap-1" onClick={addSpeechEntry}>
                                                    <BsPlusCircle size={16} />
                                                    Add Entry
                                                </button>
                                            </div>

                                            {speechEntries.length === 0 ? (
                                                <div className="text-center py-4" style={{ background: '#f8f9fa', borderRadius: '8px' }}>
                                                    <i className="bi bi-inbox" style={{ fontSize: '2rem', color: '#adb5bd' }}></i>
                                                    <p className="text-muted mt-2 mb-0">No entries added yet. Click "Add Entry" to add speech routing entries.</p>
                                                </div>
                                            ) : (
                                                <>
                                                    {/* Header Row */}
                                                    <div className="row g-3 mb-1 fw-semibold text-muted small">
                                                        <div className="col-auto">#</div>
                                                        <div className="col-md-5">
                                                            <label className="form-label mb-0">
                                                                Type <span className="text-danger">*</span>
                                                                <Tooltip title="Enter the speech keyword or category (e.g. Support, Sales)" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 0.5 }} />
                                                                </Tooltip>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="form-label mb-0">
                                                                Agent <span className="text-danger">*</span>
                                                                <Tooltip title="Select the destination agent for this speech entry" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 0.5 }} />
                                                                </Tooltip>
                                                            </label>
                                                        </div>
                                                        <div className="col-auto">
                                                            <label className="form-label mb-0">Action</label>
                                                        </div>
                                                    </div>

                                                    {/* Entry Rows */}
                                                    {speechEntries.map((entry, i) => (
                                                        <div className="row g-3 mb-2 align-items-center" key={i}>
                                                            <div className="col-auto">
                                                                <span className="fw-bold">{i + 1}</span>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="e.g. Support, Sales"
                                                                    value={entry.type}
                                                                    onChange={(e) => changeSpeechEntry(e.target.value, i, 'type')}
                                                                />
                                                            </div>
                                                            <div className="col-md-4">
                                                                <select
                                                                    className="form-select"
                                                                    value={entry.agent}
                                                                    onChange={(e) => changeSpeechEntry(e.target.value, i, 'agent')}
                                                                >
                                                                    <option value="">-- Select Agent --</option>
                                                                    {agents.map((agent) => (
                                                                        <option key={agent.agent_id} value={agent.agent_id}>
                                                                            {agent.agent_name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className="col-auto">
                                                                <BsTrash
                                                                    size={18}
                                                                    className="text-danger cursor-pointer"
                                                                    title="Delete"
                                                                    onClick={() => removeSpeechEntry(i)}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </>
                                            )}
                                        </div>

                                        <div className="d-flex justify-content-end gap-2 mt-4">
                                            <button type="button" className="btn btn-secondary" onClick={() => navigate('/configurations/ivrconfigurations')}>
                                                Cancel
                                            </button>
                                            <button type="button" onClick={handleSpeechSave} className="btn btn-primary">
                                                <i className="bi bi-check-circle me-1"></i> {editMode && ivrID ? 'Update IVR' : 'Save IVR'}
                                            </button>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>




                        {/* SUCCESS MODAL */}
                        <Modal
                            show={showSuccessModal}
                            onHide={() => setShowSuccessModal(false)}
                            centered
                            backdrop="static"
                            contentClassName="border-0 shadow-lg rounded-4"
                        >
                            <Modal.Body className="p-4 text-center">
                                {/* Icon */}
                                <div
                                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                    style={{
                                        width: 80,
                                        height: 80,
                                        background: "linear-gradient(135deg, #28a745, #20c997)",
                                    }}
                                >
                                    <i className="bi bi-check-lg text-white" style={{ fontSize: "2.5rem" }} />
                                </div>

                                {/* Title */}
                                <h5 className="fw-bold mb-2">Success</h5>

                                {/* Message */}
                                <p className="text-muted mb-4">{successMessage}</p>

                                {/* Action */}
                                <Button
                                    variant="success"
                                    className="px-4 fw-semibold rounded-pill"
                                    onClick={() => setShowSuccessModal(false)}
                                >
                                    Done
                                </Button>
                            </Modal.Body>
                        </Modal>


                        {/* ERROR MODAL */}
                        <Modal
                            show={showErrorModal}
                            onHide={() => setShowErrorModal(false)}
                            centered
                            backdrop="static"
                            contentClassName="border-0 shadow-lg rounded-4"
                        >
                            <Modal.Body className="p-4 text-center">
                                {/* Icon */}
                                <div
                                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                    style={{
                                        width: 80,
                                        height: 80,
                                        background: "linear-gradient(135deg, #dc3545, #ff6b6b)",
                                    }}
                                >
                                    <i className="bi bi-x-lg text-white" style={{ fontSize: "2.2rem" }} />
                                </div>

                                {/* Title */}
                                <h5 className="fw-bold mb-2">Something went wrong</h5>

                                {/* Message */}
                                <p className="text-muted mb-4">{errorMessage}</p>

                                {/* Action */}
                                <Button
                                    variant="outline-danger"
                                    className="px-4 fw-semibold rounded-pill"
                                    onClick={() => setShowErrorModal(false)}
                                >
                                    Close
                                </Button>
                            </Modal.Body>
                        </Modal>


                        {/* CREATE AUDIO MODAL (Add Audio) */}
                        <Modal
                            show={showAudioModal}
                            onHide={() => { setShowAudioModal(false); resetAudio(); }}
                            centered
                            size="lg"
                            backdrop="static"
                        >
                            <Modal.Header closeButton className="border-1 light-modal-header" style={{ backgroundColor: '#dee1f3' }}>
                                <Modal.Title className="" style={{ color: '#014670' }}>
                                    <i className="bi bi-mic-fill me-1"></i> Create Audio
                                </Modal.Title>
                            </Modal.Header>

                            <Form onSubmit={handleAudioSave}>
                                <Modal.Body>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">
                                                Audio Name <span className="text-danger">*</span>
                                                <Tooltip title="Enter a descriptive name for this audio file" arrow placement="top">
                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                </Tooltip>
                                            </label>
                                            <input
                                                className={`form-control ${errorsAudio.audioName ? 'is-invalid' : ''}`}
                                                {...registerAudio("audioName", { required: "Audio Name is required" })}
                                            />
                                            {errorsAudio.audioName && <div className="invalid-feedback d-block">{errorsAudio.audioName.message}</div>}
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">
                                                Language  <span className="text-danger">*</span>
                                                <Tooltip title="Select the language for text-to-speech conversion" arrow placement="top">
                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                </Tooltip>
                                            </label>
                                            <select
                                                className={`form-select ${errorsAudio.language ? 'is-invalid' : ''}`}
                                                {...registerAudio("language", { required: "Language is required" })}
                                            >
                                                <option value="">Select</option>
                                                <option value="en-US">English (USA)</option>
                                                <option value="en-IN">English (India)</option>
                                                <option value="hi-IN">Hindi (India)</option>
                                                <option value="te-IN">Telugu (India)</option>
                                                <option value="ta-IN">Tamil (India)</option>
                                                <option value="kn-IN">Kannada (India)</option>
                                                <option value="ml-IN">Malayalam (India)</option>
                                                <option value="mr-IN">Marathi (India)</option>
                                                <option value="bn-IN">Bengali (India)</option>
                                                <option value="gu-IN">Gujarati (India)</option>
                                            </select>
                                            {errorsAudio.language && <div className="invalid-feedback d-block">{errorsAudio.language.message}</div>}
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label fw-semibold">
                                                Text  <span className="text-danger">*</span>
                                                <Tooltip title="Enter the text that will be converted to speech for the IVR" arrow placement="top">
                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                </Tooltip>
                                            </label>
                                            <textarea
                                                rows={3}
                                                className={`form-control ${errorsAudio.description ? 'is-invalid' : ''}`}
                                                placeholder="Enter the text to convert to audio"
                                                {...registerAudio("description", { required: "Text is required" })}
                                            />
                                            {errorsAudio.description && <div className="invalid-feedback d-block">{errorsAudio.description.message}</div>}
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">
                                                Voice Gender  <span className="text-danger">*</span>
                                                <Tooltip title="Choose whether the voice should be male or female" arrow placement="top">
                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                </Tooltip>
                                            </label>
                                            <select
                                                className={`form-select ${errorsAudio.gender ? 'is-invalid' : ''}`}
                                                {...registerAudio("gender", { required: "Voice Gender is required" })}
                                            >
                                                <option value="">Select</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                            {errorsAudio.gender && <div className="invalid-feedback d-block">{errorsAudio.gender.message}</div>}
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">
                                                Voice  <span className="text-danger">*</span>
                                                <Tooltip title="Select a specific voice variant based on language and gender selection" arrow placement="top">
                                                    <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                </Tooltip>
                                            </label>
                                            <select
                                                className={`form-select ${errorsAudio.voice ? 'is-invalid' : ''}`}
                                                disabled={!watchedLanguage || !selectedGender}
                                                {...registerAudio("voice", { required: "Voice is required" })}
                                            >
                                                <option value="">
                                                    {!watchedLanguage || !selectedGender ? "Select Language & Gender First" : "Select Voice"}
                                                </option>
                                                {voices.map((voice, idx) => (
                                                    <option key={idx} value={voice.name}>{voice.name}</option>
                                                ))}
                                            </select>
                                            {errorsAudio.voice && <div className="invalid-feedback d-block">{errorsAudio.voice.message}</div>}
                                        </div>

                                    </div>
                                </Modal.Body>

                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowAudioModal(false)}>Cancel</Button>
                                    <Button type="submit" variant="primary">Save Audio</Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>

                    </div>
                </div>
            </div>
        </div>
    );
}
